// extracted by mini-css-extract-plugin
export var chip = "_ao-0";
export var filterDropdown = "_ao-5";
export var filterItem = "_ao-6";
export var icon = "_ao-1";
export var removeButton = "_ao-3";
export var removeIcon = "_ao-4";
export var separator = "_ao-2";